
// auth services
const LOGIN_URL = process.env.ENDPOINT + 'auth/login/'
const CHECK_TOKEN_URL = process.env.ENDPOINT + 'auth/check-token/'
const CHECK_FACEBOOK_TOKEN_URL = process.env.ENDPOINT + 'auth/facebook/'
const REGISTRATION_URL = process.env.ENDPOINT + 'auth/registration/'
const LOST_LOGIN_URL = process.env.ENDPOINT + 'auth/password/reset/'
const RESET_PWD_URL = process.env.ENDPOINT + 'auth/password/reset/confirm/'
const VERIFY_EMAIL_URL = process.env.ENDPOINT + 'auth/registration/verify-email/'
const LOGOUT_URL = process.env.ENDPOINT + 'auth/logout/'
const CHANGE_PWD_URL = process.env.FRONTPOINT + 'resetpwd/'

// assets services
const LIST_IMAGE_URL = process.env.ENDPOINT + 'assets/images/'
const CROP_URL = process.env.ENDPOINT + 'assets/images/crop/'
const UPLOAD_URL = process.env.ENDPOINT + 'upload/'
const BINARY_UPLOAD_URL = process.env.ENDPOINT + 'upload/binary/'

// Blog services
const BLOG_POST_URL = process.env.ENDPOINT + 'content/'
const LIKE_URL = process.env.ENDPOINT + 'content_like/'
const DISLIKE_URL = process.env.ENDPOINT + 'content_like/'

// Pages services
const PAGE_URL = process.env.ENDPOINT + 'content/'

// comment service
const COMMENT_URL = process.env.ENDPOINT + 'comment/'

// User services
const CHECK_LOGIN_URL = process.env.ENDPOINT + 'api/user/check/'
const CHECK_EMAIL_URL = process.env.ENDPOINT + 'api/user/check/email/'
const GET_USER_FROM_TOKEN_URL = process.env.ENDPOINT + 'user/token/'
const GET_USER_FROM_PK_URL = process.env.ENDPOINT + 'user/'
const USER_AVATAR = process.env.ENDPOINT + 'user_avatar/'

  // delete a user
  // confirm a user
  // create a confirmed user
  // send an invitation email

// blood bowl services
const ROSTER_LIST_URL = process.env.ENDPOINT + 'roster/'
const TEAM_URL = process.env.ENDPOINT + 'team/'
const SKILL_LIST_URL = process.env.ENDPOINT + 'skills/'
const SKILL_LIST_FOR_PLAYER_URL = process.env.ENDPOINT + 'skills/player/'
const ADD_BASE_SKILLS_URL = process.env.ENDPOINT + 'evolution/addbaseskills/'

// Player upgrades services
const PUBLISH_BASE_UPGRADES = process.env.ENDPOINT + 'player_base_upgrade/publish/'

// match report
const MATCH_REPORT_ROOT = process.env.ENDPOINT + 'match_report/'

// ranking service
const RANKING_URL = process.env.ENDPOINT + 'ranking/'

// player service
const PLAYER_URL = process.env.ENDPOINT + 'player/'
const PLAYER_UPGRADE_ROOT = process.env.ENDPOINT + 'player_upgrade/'
const PLAYER_UPGRADE_BULK_PUBLISH_ROOT = process.env.ENDPOINT + 'player_upgrade/publish/'

// player report service
const PLAYER_REPORT_URL = process.env.ENDPOINT + 'player_report/'
const STAR_REPORT_URL = process.env.ENDPOINT + 'star_report/'
const TEAM_REPORT_URL = process.env.ENDPOINT + 'team_report/'

const MATCH_WEEK_URL = process.env.ENDPOINT + 'week/'

const CLUB_URL = process.env.ENDPOINT + 'club/'
const LEAGUE_URL = process.env.ENDPOINT + 'league/'

const NOTIFICATION_URL = process.env.ENDPOINT + 'notification/'
const CONTENT_TYPE_URL = process.env.ENDPOINT + 'content_type/'

const REFEREE_URL = process.env.ENDPOINT + 'referee/'
const STADIUM_URL = process.env.ENDPOINT + 'stadium/'
const SPONSOR_URL = process.env.ENDPOINT + 'sponsor/'
const PLAYER_CUSTOMIZATION_URL = process.env.ENDPOINT + 'player_customization/'

const EXTRA_WINNING_URL = process.env.ENDPOINT + 'extra_winnings/'

const NAV_GUARD_TEAM = process.env.ENDPOINT + 'nav_guard/team/'
const NAV_GUARD_CAN_FINISH_PURCHASE = process.env.ENDPOINT + 'nav_guard/canFinishPurchase/'

const POLL_URL = process.env.ENDPOINT + 'poll_game/'
const POLL_RESPONSE_URL = process.env.ENDPOINT + 'poll_game/response/'

const SEASON_BREAK_INFOS_URL = process.env.ENDPOINT + 'season_break/'
const CUSTOM_TEAM_SBI_URL = process.env.ENDPOINT + 'custom_team_sbi/'
const CUSTOM_PLAYER_SBI_URL = process.env.ENDPOINT + 'custom_player_sbi/'

const NUFFLE_PRAYERS_URL = process.env.ENDPOINT + 'nuffle_prayers/'
export default {
  LOGIN_URL,
  CHECK_TOKEN_URL,
  CHECK_FACEBOOK_TOKEN_URL,
  REGISTRATION_URL,
  LOST_LOGIN_URL,
  RESET_PWD_URL,
  VERIFY_EMAIL_URL,
  LOGOUT_URL,
  CHANGE_PWD_URL,

  LIST_IMAGE_URL,
  CROP_URL,
  UPLOAD_URL,
  BINARY_UPLOAD_URL,

  BLOG_POST_URL,
  LIKE_URL,
  DISLIKE_URL,

  COMMENT_URL,

  CHECK_LOGIN_URL,
  CHECK_EMAIL_URL,
  GET_USER_FROM_TOKEN_URL,
  GET_USER_FROM_PK_URL,
  USER_AVATAR,

  ROSTER_LIST_URL,
  TEAM_URL,
  SKILL_LIST_URL,
  ADD_BASE_SKILLS_URL,
  SKILL_LIST_FOR_PLAYER_URL,

  PUBLISH_BASE_UPGRADES,

  MATCH_REPORT_ROOT,

  RANKING_URL,

  PLAYER_URL,
  PLAYER_UPGRADE_ROOT,
  PLAYER_UPGRADE_BULK_PUBLISH_ROOT,

  PLAYER_REPORT_URL,
  STAR_REPORT_URL,
  TEAM_REPORT_URL,

  MATCH_WEEK_URL,
  CLUB_URL,
  LEAGUE_URL,
  NOTIFICATION_URL,

  PAGE_URL,
  CONTENT_TYPE_URL,

  REFEREE_URL,
  STADIUM_URL,
  SPONSOR_URL,

  PLAYER_CUSTOMIZATION_URL,
  EXTRA_WINNING_URL,

  NAV_GUARD_TEAM,
  NAV_GUARD_CAN_FINISH_PURCHASE,

  POLL_URL,
  POLL_RESPONSE_URL,

  SEASON_BREAK_INFOS_URL,
  CUSTOM_TEAM_SBI_URL,
  CUSTOM_PLAYER_SBI_URL,
  NUFFLE_PRAYERS_URL
}



// WEBPACK FOOTER //
// ./src/api/services.url.js